import { defineStore } from 'pinia';

export const useCommonStore = defineStore('common', {
    state: () => ({
        isFixedBgOpen: false,
        hideBgStatus: true,
    }),

    getters: {
        isFixedBg: state => state.isFixedBgOpen,
        hideFixedBgStatus: state => state.hideBgStatus,
    },

    actions: {
        setFixedBgStatus(value: boolean) {
            this.isFixedBgOpen = value;
        },

        setHideBgStatus(value: boolean) {
            this.hideBgStatus = value;
        },
    },
});
